module.exports = __webpack_public_path__ + "static/media/N10.fc7dea6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N10.svg
// module id = 193
// module chunks = 0